// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"37":"ae22fac2bb0cd9da","345":"40a9e6444aa63823"}[chunkId] + ".js";
};